import messages from "./messages"

const policyKeyMessages = (key) => {
  switch (key) {
    case "first_checkbox_policy_text":
      return messages.firstCheckboxPolicyText
    case "second_checkbox_policy_text":
      return messages.secondCheckboxPolicyText
    case "third_checkbox_policy_text":
      return messages.thirdCheckboxPolicyText
    default:
      return messages.iHaveReadAndAcceptThe
  }
}

export default policyKeyMessages
